import { LugasAreaType } from "@data-types/user/LugasAreaType";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { RequestContextType } from "@utils/api-config/RequestContext";
import { createApiRequestOptions } from "@utils/api-config/createApiRequestOptions";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";

export class LugasActivationsService {
	static baseUrl = `${WEBPACK_BASE_ADDRESS}platform/lugas-activations`;
	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};
	static getApiRequestContext(
		options: ContextOptions = createApiRequestOptions(
			RequestContextType.Online
		)
	) {
		return getApiRequestContext(options);
	}

	static async updateCurrentArea(
		userId: string,
		currentArea: LugasAreaType = LugasAreaType.SportBetting
	) {
		const url = `${this.baseUrl}/${userId}/current-area`;

		return await httpClient.put(
			url,
			JSON.stringify({ currentArea }),
			this.getRequestHeaders(this.getApiRequestContext())
		);
	}
}
